/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	OrgOrganizationsDocsRetrievePathOrgId,
	OrgOrganizationsDocsRetrieveQueryOrgUnit,
	OrgOrganizationsDocsRetrieveStatus200,
} from "../types/OrgOrganizationsDocsRetrieve.ts";

function getOrgOrganizationsDocsRetrieveUrl(org_id: OrgOrganizationsDocsRetrievePathOrgId) {
	const res = { method: "GET", url: `/api/org/organizations/${org_id}/docs/` as const };

	return res;
}

/**
 * {@link /api/org/organizations/:org_id/docs/}
 */
export async function orgOrganizationsDocsRetrieve(
	org_id: OrgOrganizationsDocsRetrievePathOrgId,
	params?: { org_unit?: OrgOrganizationsDocsRetrieveQueryOrgUnit },
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgOrganizationsDocsRetrieveStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrgOrganizationsDocsRetrieveUrl(org_id).url.toString(),
		params,
		...requestConfig,
	});

	return res.data;
}
